import(/* webpackMode: "eager" */ "/var/www/apporb-web/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["LandingFooter"] */ "/var/www/apporb-web/frontend/src/components/landing/LandingFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingNav"] */ "/var/www/apporb-web/frontend/src/components/landing/LandingNav.tsx");
